
namespace TabAurous.Retail {

    import fld = GiftVoucherItemDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemDetailsSelectGrid extends _Ext.GridBase<GiftVoucherItemDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherItemDetails'; }
        protected getDialogType() { return GiftVoucherItemDetailsDialog; }
        protected getIdProperty() { return GiftVoucherItemDetailsRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherItemDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherItemDetailsRow.localTextPrefix; }
        protected getService() { return GiftVoucherItemSelectService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
         
 
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): GiftVoucherItemDetailsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }



        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }


    }
}